// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DuhSu","footer":"styles_footer__1F-Ez","passCodeTooltip":"styles_passCodeTooltip__130zO"};